export function useTenant(): string {
    const { href } = window.location
    const sshUrls = ['schoolsupporthub.cambridge', 'ci.localhost']

    const isCi = sshUrls.some((url) => href.includes(url))

    return isCi ? 'ci' : 'tw'
}